import styled, { useTheme } from 'styled-components'

import { IconBase, IconProps } from './Base'

const IconContainer = styled.div`
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
`

const DotIndicator = styled.div<{ $isActive: boolean }>`
  position: absolute;
  top: 0px;
  right: 0px;
  transform: translate(50%, -50%);
  width: 8px;
  height: 8px;
  background-color: ${props => props.theme.colors.background.success};
  border-radius: 50%;
  border: 2px solid ${props => props.theme.colors.background.primary};
  display: ${props => (props.$isActive ? 'block' : 'none')};
`

export const IconFilter = (props: IconProps & { isActive?: boolean }) => {
  const theme = useTheme()
  return (
    <IconContainer>
      <IconBase {...props} width={props.width || 16} height={props.height || 16} viewBox="0 0 16 16" fill="none">
        <g id="Frame">
          <path
            id="Vector"
            d="M14.6668 2H1.3335L6.66683 8.30667V12.6667L9.3335 14V8.30667L14.6668 2Z"
            stroke={theme.colors.text.primary}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </IconBase>
      <DotIndicator $isActive={!!props.isActive} />
    </IconContainer>
  )
}

export const IconFilterTrigger = (props: IconProps) => {
  const theme = useTheme()
  return (
    <IconContainer>
      <IconBase {...props} width={props.width || 24} height={props.height || 24} viewBox="0 0 24 24" fill="none">
        <g clipPath="url(#clip0_6655_23328)">
          <path
            d="M21 4H14"
            stroke={theme.colors.text.primary}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M10 4H3"
            stroke={theme.colors.text.primary}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M21 12H12"
            stroke={theme.colors.text.primary}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M8 12H3"
            stroke={theme.colors.text.primary}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M21 20H16"
            stroke={theme.colors.text.primary}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M12 20H3"
            stroke={theme.colors.text.primary}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M14 2V6"
            stroke={theme.colors.text.primary}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M8 10V14"
            stroke={theme.colors.text.primary}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M16 18V22"
            stroke={theme.colors.text.primary}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_6655_23328">
            <rect width="24" height="24" fill="white" />
          </clipPath>
        </defs>
      </IconBase>
    </IconContainer>
  )
}
